export default __webpack_public_path__ + "static/media/vid-rbs.86222609.mp4";